import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "eY/27u",
    defaultMessage: "Content Pages",
    description: "wizard step title",
  },
  description: {
    id: "McZvFm",
    defaultMessage:
      "Create essential content pages like Home, About Us, Contact, and Terms & Conditions.",
    description: "wizard step description",
  },
  successMessage: {
    id: "CMgwzb",
    defaultMessage: "Content page created",
    description: "wizard step success notification",
  },
  errorMessage: {
    id: "SMbwIq",
    defaultMessage: "Failed to create page",
    description: "wizard step error notification",
  },
  updateSuccessMessage: {
    id: 'js2zOc',
    defaultMessage: "Content page updated",
    description: "wizard step update success notification",
  },
  update: {
    id: 'MHpIml',
    defaultMessage: "Update",
    description: "update button label",
  },
  pageType: {
    id: "WoXH/8",
    defaultMessage: "Page Type",
    description: "form field label",
  },
  pageTypeHelper: {
    id: "TZ8tUh",
    defaultMessage: "Select the type of content page to create",
    description: "form field helper text",
  },
  pageTitle: {
    id: "v+5sve",
    defaultMessage: "Page Title",
    description: "form field label",
  },
  pageTitleHelper: {
    id: "djd/Vt",
    defaultMessage: "e.g., About Us, Contact, Terms & Conditions",
    description: "form field helper text",
  },
  urlSlug: {
    id: "vGF52J",
    defaultMessage: "URL Slug",
    description: "form field label",
  },
  urlSlugHelper: {
    id: "Dbam4Q",
    defaultMessage: "URL-friendly version of the title (e.g., about-us)",
    description: "form field helper text",
  },
  pageContent: {
    id: '9DuP3G',
    defaultMessage: "Content",
    description: "form field label",
  },
  pageContentHelper: {
    id: 'Es7+Le',
    defaultMessage: "Page body text",
    description: "form field helper text",
  },
  publishImmediately: {
    id: "4MCxNA",
    defaultMessage: "Publish page immediately",
    description: "form checkbox label",
  },
  addPage: {
    id: '9QfFdO',
    defaultMessage: "Add Page",
    description: "add button label",
  },
  cancel: {
    id: 'uT5L4h',
    defaultMessage: "Cancel",
    description: "cancel button label",
  },
  save: {
    id: '9xwH9i',
    defaultMessage: "Save",
    description: "save button label",
  },
  emptyPages: {
    id: 'Bj4aFb',
    defaultMessage: "No content pages yet. Add one to get started.",
    description: "empty state message",
  },
  titleColumn: {
    id: '0+1HEr',
    defaultMessage: "Title",
    description: "table column header",
  },
  slugColumn: {
    id: 'VDB23i',
    defaultMessage: "Slug",
    description: "table column header",
  },
  statusColumn: {
    id: 'ifaz/x',
    defaultMessage: "Status",
    description: "table column header",
  },
  published: {
    id: 'G1KzEx',
    defaultMessage: "Published",
    description: "page status",
  },
  draft: {
    id: 'mTDLVf',
    defaultMessage: "Draft",
    description: "page status",
  },
});
